<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Modification du slide n°{{ id }}</h2>
            
            <form action="" method="POST" @submit.prevent="validation">
                <label>Image</label>
                <input type="file" @change="new_image= $event.target.files[0]" accept="image/*" />
                <p>Le format de l'image doit être de 796 x 438</p>
                
                <p v-if="erreurDescription">{{ erreurDescription }}</p>
                <label>Description</label>
                <input type="text" :value="description" @input="description= $event.target.value" @focus="erreursDescription" @keyup="erreursDescription" :class="{ border: erreurDescription }" />
                
                <p v-if="erreurTexteBouton">{{ erreurTexteBouton }}</p>
                <label>Texte du bouton</label>
                <input type="text" :value="action_title" @input="action_title= $event.target.value" @focus="erreursTexteBouton" @keyup="erreursTexteBouton" :class="{ border: erreurTexteBouton }"/>
                
                <p v-if="erreurLien">{{ erreurLien }}</p>
                <label>Lien</label>
                <input type="text" :value="action_url" @input="action_url= $event.target.value" @focus="erreursLien" @keyup="erreursLien" :class="{ border: erreurLien }" />
                
                <input type="submit" value="Modifier" />
                
                <p v-if="alerte">{{ alerte }}</p>
            </form>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: 'AdminEditSlide', 
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                id: '',
                image_url: '',
                description: '',
                action_title: '',
                action_url: '',

                new_image: '',
                alerte: '',

                erreurDescription: '',
                erreurTexteBouton: '',
                erreurLien: '',
            }
        },
        methods: {
            getSlide() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1",
                    id: this.$route.params.slideId
                }));
                
                axios
                .post(this.$store.state.apiUrl+"?request=getSlide", formData)
                .then((response) => {
                    if(response.data.id) {
                        this.id = response.data.id;
                        this.image_url = response.data.image_url;
                        this.description = response.data.description;
                        this.action_title = response.data.action_title;
                        this.action_url = response.data.action_url;
                    }
                    else {
                        this.$router.push('../editSlider');
                    }
                })
                .catch((error) => this.$router.push('../editSlider'));
            },
            descriptionValide() {
                let valide = false;

                if (this.description && this.description.trim() && this.description.length <= 200) {
                    valide = true;
                }
                return valide;
            },
            texteBoutonValide() {
                let valide = false;

                if (this.action_title && this.action_title.trim() && this.action_title.length <= 100) {
                    valide = true;
                }
                return valide;
            },
            lienValide() {
                let valide = false;
                let regex = /^(https?):\/\/[^\s]*$/;
                
                if (this.action_url && this.action_url.trim() && regex.test(this.action_url) && this.action_url.length <= 256) {
                    valide = true;
                }
                return valide;
            },
            erreursDescription() {
                this.erreurDescription = '';

                if (!this.descriptionValide()) {
                    if (!this.description || !this.description.trim()) {
                        this.erreurDescription = 'La description est requise.';
                    } else {
                        if (this.description.length > 200) {
                            this.erreurDescription = "La description ne doit pas dépasser 200 caractères.";
                        }
                    }
                }
            },
            erreursTexteBouton() {
                this.erreurTexteBouton = '';

                if (!this.texteBoutonValide()) {
                    if (!this.action_title || !this.action_title.trim()) {
                        this.erreurTexteBouton = 'Le texte du bouton est requis.';
                    } else {
                        if (this.action_title.length > 100) {
                            this.erreurTexteBouton = 'Le texte du bouton ne doit pas dépasser 100 caractères.';
                        }
                    }
                }
            },
            erreursLien() {
                this.erreurLien = '';

                if (!this.lienValide()) {
                    if (!this.action_url || !this.action_url.trim()) {
                        this.erreurLien = "Le lien est requis.";
                    } else {
                        let regex = /^(https?):\/\/[^\s]*$/;
                        if (!regex.test(this.action_url)) {
                            this.erreurLien = "Le lien n'est pas un lien valide.";
                        }
                        if (this.action_url.length > 256) {
                            this.erreurLien = "Le lien ne doit pas dépasser 256 caractères.";
                        }
                    }
                }
            },
            validation() {
                if (this.descriptionValide() && this.texteBoutonValide() && this.lienValide()) {
                    this.editSlide();
                } else {
                    this.erreursDescription();
                    this.erreursTexteBouton();
                    this.erreursLien();
                }
            },
            editSlide() {
                let data = JSON.stringify({
                    post: '1',
                    id: this.id,
                    image_url: this.image_url,
                    description: this.description,
                    action_title: this.action_title,
                    action_url: this.action_url
                });
                
                let formData = new FormData();
                formData.append('data', data);

                // Une nouvelle image a été sélectionnée
                if(this.new_image) {
                    formData.append('file', this.new_image);
                }

                axios
                .post(
                this.$store.state.apiUrl+"?request=updateSlide", formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    if(response.data == "ratio") {
                        this.alerte = "La résolution de l'image est incorrecte";
                    }
                    else if(response.data == false) {
                        this.alerte = "Le slide n'a pas été modifié";
                    }
                    else {
                        this.alerte = "Le slide a bien été modifié";
                    }
                })
                .catch((error) => this.alerte = "Le slide n'a pas pu être modifié");
            }
        },
        mounted() {
            this.getSlide();
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
